<sw-page class="topdata-es-suggestion-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-single-select
            v-model:value="filterLanguage"
            :options="languageOptions"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.filterLanguagePlaceholder')"
            class="topdata-es-suggestion-language-filter"
            :show-clearable="true"
            @update:value="onFilterChange"
        />
        <sw-single-select
            v-model:value="filterSource"
            :options="sourceOptions"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.filterSourcePlaceholder')"
            class="topdata-es-suggestion-source-filter"
            :show-clearable="true"
            @update:value="onFilterChange"
        />
        <sw-button variant="primary" @click="onAddSuggestion">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.addButton') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :repository="repository"
            :dataSource="items"
            :columns="columns"
            identifier="topdata-es-suggestion"
            :is-loading="isLoading"
            :show-settings="false"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-targetType="{ item }">
                <sw-label
                    :variant="targetTypeVariant(item.targetType)"
                    appearance="pill"
                >
                    {{ targetTypeLabel(item.targetType) }}
                </sw-label>
            </template>

            <template #column-languageId="{ item }">
                <sw-label :variant="item.languageId ? 'default' : 'neutral'" size="small">
                    {{ getLanguageLabel(item.languageId) }}
                </sw-label>
            </template>

            <template #column-source="{ item }">
                <sw-label :variant="item.source === 'TITLE_MINING' ? 'neutral' : 'default'" size="small">
                    {{ getSourceLabel(item.source) }}
                </sw-label>
            </template>

            <template #column-targetUrl="{ item }">
                <span :title="item.targetUrl">
                    {{ targetLabelFor(item) }}
                </span>
            </template>

            <template #column-targetQuery="{ item }">
                <span v-if="item.targetQuery">{{ item.targetQuery }}</span>
                <span v-else>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.columnTargetQueryEmpty') }}</span>
            </template>

            <template #column-active="{ item }">
                <sw-icon v-if="item.active" name="regular-checkmark" color="#37d6b5" />
                <sw-icon v-else name="regular-times" color="#de294c" />
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditSuggestion(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item @click="onOpenItem(item)">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.openInNewTab') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onDeleteSuggestion(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-empty-state v-else-if="!isLoading" :title="$tc('TopdataEnhancedSearchSW6.topdata-es-suggestion.emptyState')" />

        <sw-loader v-if="isLoading" />

        <topdata-es-suggestion-form
            v-if="showFormModal"
            :entity="currentEntity"
            :repository="repository"
            @save="onCloseFormModal"
            @close="onCloseFormModal"
        />
    </template>
</sw-page>